<template>
    <div
        class="relative lg:h-screen lg:grid lg:grid-cols-2"
        :style="{
            'font-family': wall.fontFamily,
            'background-color': wall.transparentBackground ? 'transparent' : wall.wallColor,
        }"
    >
        <FormLeft :wall="wall" />
        <FormRight :wall="wall" />
    </div>
</template>

<script>
import FormLeft from "./FormLeft.vue";
import FormRight from "./FormRight.vue";

export default {
    name: "LoveFormBody",
    components: { FormLeft, FormRight },
    props: {
        wall: Object,
    },
};
</script>
